import { useRef, useEffect, useState } from "react";
import { IcCardGreen, IcCardOrange, IcCardYellow, IcSecondpageBg, Icg1cashHome, IosMockup } from "../../constants/icons";
import IcCardGreenSrc from "../../assets/images/icon/ic-card-green.png";
import mockupSrc from "../../assets/images/ios-mockup.png";
import homeSrc from "../../assets/images/g1cash-home.png";
import g1cashSrc from "../../assets/images/g1cash-g1cash.png";
import "./secondpage.css";

const SecondPageMobile = () => {
    const secondPageMobileRef = useRef(null);
    const [show, setShow] = useState(false);

    useEffect(() => {
        //for interaction
        const observer = new IntersectionObserver(
            (entries) => {
                entries.map((entry) => {
                    if (entry.isIntersecting && !entry.target.classList.contains("show")) {
                        setShow(true);
                    }
                });
            },
            { threshold: 0.2 }
        );
        observer.observe(secondPageMobileRef.current);
    }, []);

    return (
        <div className={`${show ? "show" : ""} second-mobile-page`} ref={secondPageMobileRef}>
            <div className="second-page-top">
                <div className="second-title title">
                    {"Start "}
                    <span>Spending</span>
                    {" and\n"}
                    <span>investing</span>
                    {" smarter today!"}
                </div>
                <div className="second-subtitle subtitle">
                    {"Maximize your purchasing power and watch your investments grow.\nTake control of your financial future with G1CASH."}
                </div>
            </div>
            <div className="second-page-bottom">
                <IcSecondpageBg className="second-page-bg-mobile" />

                <div className="second-page-phone-wrapper">
                    <img src={mockupSrc} className="second-page-phone" />
                    <img src={homeSrc} className="second-page-phone-bg" />
                    <img src={g1cashSrc} className="second-page-phone-bg2" />
                </div>

                <div className="second-page-card-wrapper">
                    <IcCardYellow className="second-page-yellow-card" />
                    <IcCardOrange className="second-page-orange-card" />
                    <IcCardGreen className="second-page-green-card" />
                    {/* <img src={IcCardGreenSrc} className="second-page-green-card" /> */}
                </div>
            </div>
        </div>
    );
};

export default SecondPageMobile;
